import React from "react";
import PageTitle from "../components/PageTitle/PageTitle";
import { Button } from "@material-ui/core";
import TextInput from "../widgets/TextInput";
import Loading from "../components/Loading";
import changePassword from "../services/changePassword";
import Cookies from "universal-cookie";

export default class UserSettings extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            oldP: '', 
            newP: '', 
            confirm: ''
        };

    }

    render() {

        if (this.state.isLoading) {
            return <Loading />;
        }

        return (
            <>
                <PageTitle title={'Impostazioni utente'} />

                <div style={dashboardView}>
                    <div style={inputGroup}>
                        <p style={label}>
                            Vecchia password:
                        </p>
                        <TextInput value={this.state.oldP} type="password" onChange={(t) => { 
                            this.setState({ oldP: t });
                        }} />
                    </div>

                    <div style={inputGroup}>
                        <p style={label}>
                            Nuova password:
                        </p>
                        <TextInput value={this.state.newP} type="password" onChange={(t) => { 
                            this.setState({ newP: t });
                        }} />
                    </div>

                    <div style={inputGroup}>
                        <p style={label}>
                            Conferma nuova password
                        </p>
                        <TextInput value={this.state.confirm} type="password" onChange={(t) => { 
                            this.setState({ confirm: t });
                        }} />
                    </div>
                    <Button
                        color="secondary"
                        size="small"
                        className="px-2"
                        style={button}
                        variant="contained"
                        onClick={async () => {

                            if (this.state.newP !== this.state.confirm) {
                                alert('Le password non corrispondono');
                                return;
                            }

                            this.setState({ isLoading: true });

                            let cookies = new Cookies();
                            let username = cookies.get('username', { path: '/' });
                            let token = cookies.get('token', { path: '/' });

                            let res = await changePassword(username, token, this.state.oldP, this.state.newP);
                            if (res.result === 'KO') {
                                alert(res.error);
                                return;
                            }
                            
                            this.setState({ isLoading: false });
                            alert('Password aggiornata con successo.');
                        }}
                    >
                        Aggiorna
                    </Button>
                </div>
            </>
        );
    }
}

const dashboardView = {
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 30,
    marginRight: 10,
    boxShadow: '0px 2px 4px lightgrey'
}

const label = {
    margin: 0
}

const inputGroup = {
    marginBottom: 20
}

const button = {
    width: 'fit-content',
    alignSelf: 'flex-end'
}